/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1GatewayListPoliciesRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
};

/** @internal */
export type V1GatewayListPoliciesRequestBody$Outbound = {
  project: string;
  app: string;
  environment: string;
};

/** @internal */
export const V1GatewayListPoliciesRequestBody$outboundSchema: z.ZodType<
  V1GatewayListPoliciesRequestBody$Outbound,
  z.ZodTypeDef,
  V1GatewayListPoliciesRequestBody
> = z.object({
  project: z.string(),
  app: z.string(),
  environment: z.string(),
});

export function v1GatewayListPoliciesRequestBodyToJSON(
  v1GatewayListPoliciesRequestBody: V1GatewayListPoliciesRequestBody,
): string {
  return JSON.stringify(
    V1GatewayListPoliciesRequestBody$outboundSchema.parse(
      v1GatewayListPoliciesRequestBody,
    ),
  );
}
